import React from "react";
import constate from "constate";
import useState from "./useState";

const [Provider, useContext]= constate(useState);
useContext as any;

export {Provider, useContext};
